<template>
  <b-container>
    <b-row>
      <b-col sm="12" class="package-details search-summary noPrint">
        <div class="wrap-summary">
          <div class="d-flex justify-content-md-between wrap-summary-details">
            <div v-if="params.departureName" class="d-inline-block">
              <span class="tag-details">Plecare:</span> <span class="name-details">{{ params.departureName }}</span>
            </div>
            <div class="d-inline-block">
              <span class="tag-details">Transport: </span>
              <span v-if="params.transport === 'flight'" class="name-details">Avion</span>
              <span v-if="params.transport === 'bus'" class="name-details">Autocar</span>
              <span v-if="params.transport === 'own'" class="name-details">Propriu</span>
            </div>
            <div class="d-inline-block">
              <span class="tag-details">Destinatie: </span> <span class="name-details">{{params.resortName}}</span>
            </div>
            <div class="d-inline-block">
              <span class="tag-details">Data: </span> <span class="name-details">{{departureDate}}</span>
            </div>
            <div class="d-inline-block">
              <span class="tag-details">Nr.nopti: </span> <span class="name-details">{{params.duration}}</span>
            </div>
            <div v-for="(room, index) in params.rooms" :key="index" class="d-inline-block">
              <span class="tag-details">Camera {{index + 1 }} - </span>
              <span>{{room.adults}} </span><span class="name-details"> adulti</span>
              <span v-if="room.ages && room.ages.length" class="name-details">, {{ room.ages.length }} copii</span>
            </div>
          </div>
          <div class="d-flex justify-content-end mt-2">
            <span class="blockquote-footer"><b>Oferta generata de</b> -
              <span class="name-details"> {{userData.fname}} {{userData.lname}}</span>
            </span>
          </div>
        </div>
      </b-col>
      <b-col sm="12" class="package-details search-summary  print-only w-100">
        <div class="wrap-summary">
          <table class="table w-100">
            <tr>
              <td  v-if="params.departureName"><span class="tag-details">Plecare:</span> <span class="name-details">{{ params.departureName }}</span></td>
              <td>
                <span class="tag-details">Transport: </span>
                <span v-if="params.transport === 'flight'" class="name-details">Avion</span>
                <span v-if="params.transport === 'bus'" class="name-details">Autocar</span>
                <span v-if="params.transport === 'own'" class="name-details">Propriu</span>
              </td>
              <td> <span class="tag-details">Destinatie: </span><br/> <span class="name-details">{{params.resortName}}</span></td>
              <td><span class="tag-details">Data: </span><span class="name-details">{{departureDate}}</span></td>
              <td><span class="tag-details">Nr.nopti: </span><br/> <span class="name-details">{{params.duration}}</span></td>
              <td>
                <span v-for="(room, index) in params.rooms" :key="index" class="mx-2 d-inline-block">
                <span class="tag-details">Camera {{index + 1 }} - </span><br/>
                <span>{{room.adults}} </span><span class="name-details"> adulti</span>
                <span v-if="room.ages && room.ages.length" class="name-details">, {{ room.ages.length }} copii</span>
              </span>
              </td>
            </tr>
          </table>
          <hr class="my-1">
          <small class="float-right clearfix">
            <b v-translate>generated by</b> -
            <span class="name-details"> {{userData.fname}} {{userData.lname}}</span>
          </small>
        </div>
     </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from 'moment'
import auth from '@/app/private/shared/mixins/auth'

export default {
  props: ['params'],
  mixins: [auth],
  computed: {
    departureDate: function () {
      const d = moment(this.params.date, 'X')
      return d.format('DD-MM-YYYY')
    }
  }
}
</script>
<style scoped>
.print-only{
  display: none!important;
}
</style>
